import moment, { Moment } from "moment";
import { PrizeSupplier, PrizeSupplierDTO } from "./supplier/PrizeSupplier";

export interface PrizeDTO {
  id: number;
  supplier: PrizeSupplierDTO;
  priceMargin: number;
  disabled: boolean;
  supplierItemId: string;
  name: { [locale: string]: string };
  customName: { [locale: string]: string };
  description: { [locale: string]: string };
  customDescription: { [locale: string]: string };
  nettoPrice: number;
  vatRate: number;
  isAvailable: boolean;
  assets?: { image: string }[];
  deliveryPrice: string; // "0.00"
  deliveryVatRate: number;
  availabilityDate: string;
  withdrawnBySupplier: boolean;
}

export class Prize {
  private _id: number = 0;
  private _supplier: PrizeSupplier = new PrizeSupplier();
  private _priceMargin: number = 0;
  private _disabled: boolean = false;
  private _supplierItemId: number = 0;
  private _name: string = "";
  private _customName: string = "";
  private _description: string = "";
  private _customDescription: string = "";
  private _nettoPrice: number = 0;
  private _vatRate: number = 0;
  private _isAvailable: boolean = false;
  private _image: string = "";
  private _deliveryPrice: number = 0;
  private _deliveryVatRate: number = 0;
  private _availabilityDate: Moment = moment();
  private _withdrawnBySupplier: boolean = false;
  private _useCustom: boolean = false;

  static create(prize: PrizeDTO): Prize {
    const instance = new Prize();

    instance._id = prize.id;
    instance._supplier = PrizeSupplier.create(prize.supplier);
    instance._priceMargin = prize.priceMargin || 0;
    instance._disabled = prize.disabled;
    instance._supplierItemId = Number(prize.supplierItemId);
    instance._name = prize.name.pl;
    instance._customName = prize.customName && prize.customName.pl;
    instance._description = prize.description.pl;
    instance._customDescription =
      prize.customDescription && prize.customDescription.pl;
    instance._nettoPrice = prize.nettoPrice;
    instance._vatRate = prize.vatRate;
    instance._isAvailable = prize.isAvailable;

    if (prize.assets && prize.assets.length > 0) {
      instance._image = prize.assets[0].image;
    }

    instance._deliveryPrice = Number(prize.deliveryPrice);
    instance._deliveryVatRate = prize.deliveryVatRate;
    instance._availabilityDate = moment(prize.availabilityDate);
    instance._withdrawnBySupplier = prize.withdrawnBySupplier;
    instance._useCustom = !!(
      instance._customName || instance._customDescription
    );

    return instance;
  }

  public get id() {
    return this._id;
  }

  public get supplier() {
    return this._supplier;
  }

  public get priceMargin() {
    return this._priceMargin;
  }

  public get disabled() {
    return this._disabled;
  }

  public get supplierItemId() {
    return this._supplierItemId;
  }

  public get name() {
    return this._name;
  }

  public get customName() {
    return this._customName || "";
  }

  public get description() {
    return this._description;
  }

  public get customDescription() {
    return this._customDescription || "";
  }

  public get nettoPrice() {
    return this._nettoPrice;
  }

  public get vatRate() {
    return this._vatRate;
  }

  public get isAvailable() {
    return this._isAvailable;
  }

  public get status() {
    if (!this._isAvailable || this._disabled) {
      return "unavailable";
    }

    return "available";
  }

  public get image() {
    return this._image;
  }

  public get deliveryPrice() {
    return this._deliveryPrice;
  }

  public get deliveryVatRate() {
    return this._deliveryVatRate;
  }

  public get availabilityDate() {
    return this._availabilityDate.format("DD.MM.YYYY");
  }

  public get withdrawnBySupplier() {
    return this._withdrawnBySupplier;
  }

  public get useCustom() {
    return this._useCustom;
  }
}
